import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from '@heroui/react';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button 
          variant="light" 
          className="capitalize"
        >
          {i18n.language === 'es' ? 'ES' : 'EN'}
        </Button>
      </DropdownTrigger>
      <DropdownMenu 
        aria-label="Language Selection"
        onAction={(key) => changeLanguage(key as string)}
      >
        <DropdownItem key="es">
          Español
        </DropdownItem>
        <DropdownItem key="en">
          English
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageSwitcher;